export function incompleteQuery(query, requiredParams) {
  if (isEmptyVariable(query)) return true;
  for (const param of requiredParams) {
    if (isEmptyVariable(query[param])) return true;
  }
  return false;
}

export function isEmptyVariable(variable) {
  const type = typeof variable;
  if (variable === undefined) return true;
  if (variable === null) return true;
  if (type === 'string') {
    if (removeWhitespace(variable).length === 0) return true;
    return false;
  }
  if (Array.isArray(variable)) {
    if (variable.length === 0) return true;
    return false;
  }
  if (type === 'object') {
    if (Object.keys(variable).length === 0) return true;
    return false;
  }
  if (type === 'boolean' || type === 'number' || type === 'function' || type === 'bigint' || type === 'symbol' ) return false;
  console.warn('Unknown type %s. Variable is considered as non-empty.', type);
  return false;
}

export function removeWhitespace(str) {
  return str.replace(/\s/g, "");
}